import React from 'react'
import styled from 'styled-components'
import { SharePanelExtension } from './sharePanelExtension'
import { SharePanelWeb } from './sharePanelWeb'

export const SharePanel = ({
  renderFor = 'extension',
  onClose,
  moteId,
  canRedirect
}) => {
  return (
    <Root>
      {renderFor === 'extension' && (
        <SharePanelExtension
          onClose={onClose}
          moteId={moteId}
          canRedirect={canRedirect}
        />
      )}
      {renderFor === 'web' && (
        <SharePanelWeb
          onClose={onClose}
          moteId={moteId}
          canRedirect={canRedirect}
        />
      )}
    </Root>
  )
}

const Root = styled.div``
